import { FullHeightPage } from '@client-info/features/shared/FullHeightPage';
import { GeneralError } from '@components/error/GeneralError';
import Stack from '@mui/material/Stack';
import type { QueryClient } from '@tanstack/react-query';
import {
  createRootRouteWithContext,
  HeadContent,
  Outlet,
} from '@tanstack/react-router';
import ErrorSnackbar from '../features/ErrorSnackbar';
// import { TanStackRouterDevtools } from '@tanstack/router-devtools';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

export interface RootRouterContext {
  client: QueryClient;
}

const ErrorComponent = () => (
  <FullHeightPage
    direction="row"
    sx={{ alignItems: 'center', justifyContent: 'center' }}
  >
    <GeneralError />
  </FullHeightPage>
);

const LayoutComponent = () => (
  <Stack component="main" sx={{ width: '100%' }}>
    <HeadContent />
    <ErrorSnackbar />
    <Outlet />
    {/* // Turn this on if you want to see the router devtools */}
    {/* {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />} */}
    {/* // Turn this on if you want to see the Query devtools */}
    {/* {import.meta.env.DEV && (
      <ReactQueryDevtools position="left" initialIsOpen={false} />
    )} */}
  </Stack>
);

export const Route = createRootRouteWithContext<RootRouterContext>()({
  component: LayoutComponent,
  notFoundComponent: ErrorComponent,
  errorComponent: ErrorComponent,
});
